<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button   id="print-button"  class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
        printSectionId="print-section"  [useExistingCss]="true"  ngxPrint>
      Print
      </button>

      <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
    Print
    </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('issue_seller_Invoice_Register')"
            mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div> 
    <div class="container" id="print-section1">
        <ng-container *ngIf="indetail && !datewise && !officerep">
            <!-- <div style=""> -->
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th colspan="3">
                            <p>Vivek Saptahik</p>
                        </th>
                        <th colspan="5">
                            <p>Issue Seller Registreation Report</p>
                        </th>
                        <th colspan="2">Represantative Very Briefly</th>
                        <!-- <th colspan="2"></th> -->
                        <!-- <th colspan="3"></th> -->
                        <th colspan="5">Date : {{ today | date:"dd-MM-yyyy" }}</th>
                        <th colspan="3">Page No
                            <!-- <h5 class="page-number"></h5> -->
                        </th>
                    </tr>
                    <tr>
                        <th colspan="3">
                            <div>Date. From : {{ start_date | date:"dd-MM-yyyy"}}</div>
                        </th>
                        <th colspan="2" class="leftAlign">
                            <div>To : {{ end_date | date:"dd-MM-yyyy"}}</div>
                        </th>
                        <th colspan="3" class="leftAlign">
                            <div>Issue/Grantha Category : {{ issue_category_id }}</div>
                        </th>
                        <th colspan="2" class="leftAlign">
                            <div>Issue Date : {{ issueDate | date:"dd-MM-yyyy"}}
                            </div>
                        </th>
                        <th colspan="5">Issue Name : {{ issue_name_id }}</th>
                        <th colspan="3">
                        </th>
                    </tr>
                    <tr>
                        <th>Sr.<br />No</th>
                        <th>Booking<br />Date</th>
                        <th>Booking<br />No</th>
                        <th colspan="2">Issue Seller Name</th>
                        <!-- <th>Customer<br />Name</th> -->
                        <th>Representative<br />Name</th>
                        <!-- <th>Mobile No</th> -->
                        <th>Office<br />Rep. Name</th>
                        <th>RO Number<br />Instruction</th>
                        <!-- <th></th> -->
                        <th>Issue Copies</th>
                        <th>Issue Amount.<br />Amt.</th>
                        <th>Net<br /> Amt.</th>
                        <th>GST 5%</th>
                        <th>Total<br />Amt.</th>
                        <th>Received<br />Amt.</th>
                        <th>Receipt
                            No.<br />and
                            Date</th>
                        <th>Pending<br />Amt.</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of inDetailsRegReport1; let i = index">
                        <tr>
                            <td><span>{{ i + 1 }}</span></td>
                            <td> {{item.booking_date}}</td>
                            <td>
                               {{item.booking_no}}
                            </td>
                            <td colspan="2">
                                {{item.issue_seller_id}}
                            </td>
                            <!-- <td>{{ item.cust_name }}</td> -->
                            <td>
                                {{item.rep_name}}
                            </td>
                            <!-- <td class="right"><span>{{ item['rep_mob_no'] }}</span></td> -->
                            <td>
                                {{ item['off_rep_name'] }}
                            </td>
                            <td>
                                {{ item['ro_no'] }}  
                            </td>
                            <!-- <td></td> -->
                            <td>
                            {{ item['issue_copies'] }}
                            </td>
                            <td class="right"><span>{{ item['issue_selling_amount'] }}</span></td>
                            <td class="right"><span>{{ item['amount'] }}</span></td>
                            <td class="right"><span>{{ toInt(item['sgst']) + toInt(item['cgst']) }}</span></td>
                            <td class="right"><span>{{ item['igst'] }}</span></td>
                            <td class="right"><span>{{ item['part_pymt_amt'] }}</span></td>
                            <td>{{ item['rep_rcpt_no'] }}
                                <ng-container *ngIf="item['rcpt_date'] != '0000-00-00'">
                                    <br />{{ item['rcpt_date'] | date:"dd-MM-yyy" }}
                                </ng-container>
                            </td>
                            <td class="right"><span>{{ item['part_pymt_remaning_amt'] }}</span></td>
                        </tr>
                    </ng-container>
                    <tr>
                        <td></td>
                        <!-- <td></td> -->
                        <td colspan="4" class="boldText">
                            <p>Total No of Advt : <b>{{ this.inDetailsRegReportTotal.total_advt }}</b></p>
                        </td>
                        <!-- <td colspan="2"></td> -->
                        <!-- <td></td> -->
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.advt_total }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.net_amt }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.gst }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.total_amt }}</b></span></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.rcvd_amt }}</b></span></td>
                        <td></td>
                        <td class="right"><span><b>{{ this.inDetailsRegReportTotal.pndg_amt }}</b></span></td>
                    </tr>
                </tbody>
            </table>
            <!-- </div> -->
        </ng-container>
       
    </div>

    <div class="container" >
        <div *ngIf="type=='Briefly'">
            <div id="print-section" style="margin-top: 20px;">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th colspan="3" style="border:none" class="br-bottom br-right br-top">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक  </th>
                            <th colspan="2" style="border:none" class="br-bottom br-right br-top">अंकाचे नाव : &nbsp; {{newissuedatepp}}  </th>

                            <th colspan="4" style="border:none" class="br-bottom br-right br-top">Issue/Grantha Register Report - Briefly</th>
                            <!-- <th colspan="2"  style="border:none" class="br-bottom br-right br-top">अंकाचे कॅटेगरी : &nbsp; {{issue_cat}}</th>  -->
                            <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                           
                            <th colspan="4" style="border:none" class="br-bottom br-right br-top"> Date : From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}</th>                   
                             <!-- <th colspan="3" style="border:none" class="br-bottom br-right br-top">दिनांक :{{today1}}</th> -->
                            <th colspan="2" style="border:none" class="br-bottom br-top">पृष्ठ क्र :1</th>
                            
                        </tr>
                        <tr>
                            <th colspan="3">issue/Grantha Category</th>
                            <th colspan="1">{{categoryNameForHTML}}</th>
                            <th colspan="2"></th>
                            <th colspan="3">Issue Name</th>
                            <th colspan="6">{{issueNameForHTML}}</th>
                          </tr>
                        <tr>
                            <th colspan="1"  class="br-bottom br-right">Sr</th>
                            <th colspan="1"  class="br-bottom br-right">Booking Date</th>
                            <th colspan="1"  class="br-bottom br-right">Booking No</th>
                            <th colspan="1"  class="br-bottom br-right">Seller Name</th>
                            <th colspan="1"  class="br-bottom br-right">Represntive Name</th>
                            <th colspan="1"  class="br-bottom br-right">Mobile Number</th>
                            <th colspan="1"  class="br-bottom br-right">Office Rep Name</th>
                            <th colspan="1"  class="br-bottom br-right" style="text-align: end;">Price</th>
                            <th colspan="1"  class="br-bottom br-right" style="text-align: end;">No. Of Copies</th>
                            <th colspan="1"  class="br-bottom br-right" style="text-align: end;">Total Amount</th>
                            <th colspan="1"  class="br-bottom br-right" style="text-align: end;">Disc Amt</th>
                            <th colspan="1"  class="br-bottom br-right" style="text-align: end;">Net Amt</th>
                            <th colspan="1"  class="br-bottom br-right" style="text-align: end;">जमा बाकी</th>
                            <th colspan="1"  class="br-bottom" style="text-align: end;">येणे बाकी</th>
                        </tr>   
                    </thead>
                    <tbody *ngFor="let item of filteredinDetailsRegReport; let i = index">
                        <tr>
                      <td colspan="1" style="font-weight: bold;" class=" br-right">{{i+1}}</td>
                    
                      <td colspan="1"  class="br-right">{{item.booking_date | date: "dd-MM-yyy"}}</td>
                      <td colspan="1"  class="br-right">{{item.booking_number}}</td>
                      <td colspan="1"  class="br-right">{{item.issue_seller_id}}</td>
                      <td colspan="1"  class=" br-right">{{item.representative_id}}</td>
                      <td colspan="1"  class=" br-right">{{item.rep_mob_no}}</td>
                      <td colspan="1"  class=" br-right">{{item.office_representation_id}}</td>
                      <td colspan="1" style=" text-align: right;" class="br-right">{{item.issue_seller_price}}</td>
                      <td colspan="1" style=" text-align: right;" class=" br-right">{{item.issue_copies}}</td>
                      <td colspan="1" style=" text-align: right;" class="br-right">{{item.issue_selling_amount | number: '1.2-2'}}</td>
                      <td colspan="1" style=" text-align: right;" class="br-right">{{item.issue_selling_discount_amt | number: '1.2-2'}}</td>
                      <td colspan="1" style=" text-align: right;" class="br-right">{{item.net_amount | number: '1.2-2'}}</td>
                      <td colspan="1" style=" text-align: right;" class=" br-right">{{item.entry_amt}}</td>
                      <td colspan="1" style=" text-align: right;" class=" br-right">  {{ item['net_amount'] - item.entry_amt }}</td>     

                    </tr>
                    </tbody>
        
                    <tfoot>
                        <!-- 18 -->
                        <tr>
                            <td class="br-bottom br-right br-top" style=" font-weight: bold;background-color: #e8f0ff;"></td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;" colspan="6">एकूण</td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;" >{{ totalAmounts.issue_seller_price | number: '1.2-2'  }}</td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;" >{{ totalAmounts.issue_seller_copies | number: '1.0-0'}}</td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;" >{{totalAmounts.total_amount | number: '1.2-2'}}</td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;" >{{totalAmounts.issue_selling_discount_amt | number: '1.2-2'}}</td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;">{{totalAmounts.net_amount | number: '1.2-2'}}</td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;">{{totalAmounts.rcvamount| number:
                                '1.2-2'}}</td>
                            <td class="br-bottom br-right br-top" style="text-align: right; font-weight: bold;background-color: #e8f0ff;">
                                {{ (totalAmounts.net_amount - totalAmounts.rcvamount) | number: '1.2-2' }}
                            </td>
                    
                            
                        </tr>
                    </tfoot>  
                </table>
               
            </div>
        </div>
    </div>

</div>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>